import { render, staticRenderFns } from "./LKRoadmapsFeedLabelDate.vue?vue&type=template&id=5469a1ff&"
import script from "./LKRoadmapsFeedLabelDate.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedLabelDate.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedLabelDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports